// extracted by mini-css-extract-plugin
module.exports = {"control":"index_control__usTdw"};